import { render, staticRenderFns } from "./DouobIcon.vue?vue&type=template&id=f9b45fd0"
import script from "./DouobIcon.vue?vue&type=script&lang=js"
export * from "./DouobIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports